import {
  Form as AriaForm,
  FieldError as AriaFieldError,
  type FormProps as AriaFormProps,
  type FieldErrorProps as AriaFieldErrorProps,
} from 'react-aria-components';
import { cn } from '@/foundation/utils/cn';

interface FormProps extends AriaFormProps {
  className?: string;
}

export function Form({ className, ...props }: FormProps) {
  return <AriaForm className={cn('flex flex-col gap-4', className)} {...props} />;
}

interface FieldErrorProps extends AriaFieldErrorProps {
  className?: string;
}

export function FieldError({ className, ...props }: FieldErrorProps) {
  return (
    <AriaFieldError
      className={cn('text-xs text-[var(--color-error-text)]', className)}
      {...props}
    />
  );
}
